<script>
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import Card from "../Card.svelte";
  import { isExternalUrl } from "$lib/utilities/url-helpers";
  import ExternalLinkLabel from "$lib/components/ExternalLinkLabel.svelte";

  import { page } from "$app/stores";

  /** @type {"3up" | "4up" | "6up"} */
  export let size = "3up";

  export let url = "";
  export let name = "";
  export let location = "";
  export let role = "";

  export let imageComponent;
  export let resizeParams;
  export let widthsAt = {};

  $: isExternal = isExternalUrl(url, $page.url?.origin);
  // have to request pngs as jpg to get proper styling
  $: fm = imageComponent?.fields.imageAsset?.fields?.file?.url?.endsWith("png") ? "jpg" : "webp";
</script>

<Card
  {url}
  class="group flex flex-row md:flex-col justify-center items-center gap-x-16 gap-y-16 border border-neutral-300 rounded-5 md:border-none bg-white md:bg-none p-16 md:p-0 hover:underline"
  let:hasFocus
>
  <!-- body -->
  <div class="flex flex-col grow items-start md:items-center text-left md:text-center order-2">
    <!-- name -->
    <a
      href={url}
      class="heading-card text-black no-underline font-normal focus:bg-none focus:outline-none group-focus:!no-underline active:text-black {size ===
      '6up'
        ? 'text-size-16'
        : 'text-size-16 md:text-size-24'}"
      data-sveltekit-reload
      target={isExternal ? "_blank" : null}
      rel={isExternal ? "noopener noreferrer" : null}
      on:click={(e) => {
        e.stopPropagation();
      }}
    >
      {#if isExternal}
        <ExternalLinkLabel text={name} />
      {:else}
        {name}
      {/if}
    </a>

    <!-- location -->
    {#if location}
      <p
        class="font-bold pt-4 md:pt-8 {size === '6up'
          ? 'text-size-14'
          : 'text-size-14 md:text-size-16'}"
      >
        {location}
      </p>
    {/if}

    <!-- role -->
    {#if role}
      <p
        class="pt-4 md:pt-8 font-normal {size === '6up'
          ? 'text-size-12 leading-4'
          : 'text-size-12 md:text-size-16 leading-4 md:leading-6'} "
      >
        {role}
      </p>
    {/if}
  </div>

  <!-- image -->
  {#if imageComponent}
    <ImageComponent
      containerClass="flex-shrink-0 relative w-96 md:w-full rounded-full border-2 border-transparent group-hover:border-black group-hover:drop-shadow-[0px_4px_0px_#111111] group-focus:border-4 group-focus:border-black group-focus:drop-shadow-card-avatar-focus group-focus:after:content-[''] group-focus:after:shadow-card-avatar-focus group-focus:after:block group-focus:after:h-full group-focus:after:absolute group-focus:after:top-0 group-focus:after:w-full group-focus:after:rounded-full {hasFocus &&
        "border-4 !border-black drop-shadow-card-avatar-focus after:content-[''] after:shadow-card-avatar-focus after:block after:h-full after:absolute after:top-0 after:w-full after:rounded-full after:border"}"
      elementClass="w-full aspect-square object-cover rounded-full"
      data={imageComponent}
      displayCaption={false}
      responsive
      resizeParams={{ ...resizeParams, fm }}
      {...widthsAt}
    />
  {/if}
</Card>
